import React, { useState } from 'react';
import './CareerCoachEnrollment.css';

function CareerCoachEnrollment() {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  return (
    <div className="career-coach-enrollment">
      <div className="career-coach-enrollment-content">
        <h1 className="career-coach-enrollment-title">Career Coach Enrollment</h1>
        <p className="career-coach-enrollment-intro-text">
          Welcome to the <strong>Career Coach Enrollment</strong> program! Our goal is to connect you with the students and working professionals with ambitions
          and help them with their career development. Below, you will find details regarding the enrollment process.
        </p>

        <div className="career-coach-enrollment-details-section">
          <h2 className="career-coach-enrollment-section-title">Enrollment Details</h2>
          <ul className="career-coach-enrollment-details-list">
            <li className="career-coach-enrollment-detail-item">
              <span className="career-coach-enrollment-detail-label">Approval Needed:</span> You must be approved to participate.
            </li>
            <li className="career-coach-enrollment-detail-item">
              <span className="career-coach-enrollment-detail-label">Processing Time:</span> Enrollment may take up to <strong>2 days</strong>.
            </li>
            <li className="career-coach-enrollment-detail-item">
              <span className="career-coach-enrollment-detail-label">Required Documents:</span> Please upload the following documents:
              <ul className="career-coach-enrollment-documents-list">
                <li>Profile Picture (Clear and Decent Quality)</li>
                <li>Resume Document</li>
                <li>Proof of Identity (Aadhar, PAN, or Driving License)</li>
              </ul>
            </li>
          </ul>
        </div>

        <p className="career-coach-enrollment-enrollment-note">
          Once your documents are uploaded, you will be reviewed for approval. Please ensure all documents are clear and legible.
        </p>

        <div className="terms-container">
          <input
            type="checkbox"
            id="agreeTerms"
            className="terms-checkbox"
            checked={isChecked}
            onChange={handleCheckboxChange}
          />
          <label htmlFor="agreeTerms" className="terms-label">
            I agree to the
            <a href="/#/coach-enroll-terms-and-conditions" className="terms-link">Terms and Conditions</a>and
            <a href="/#/privacy-policy" className="terms-link">Privacy Policy</a>.
          </label>
        </div>

        <a
          href="/#/career-coach-enrollment-form"
          className="career-coach-enrollment-enroll-now-button"
          style={{ pointerEvents: isChecked ? 'auto' : 'none', opacity: isChecked ? 1 : 0.5 }}
        >
          Enroll Now
        </a>
      </div>
    </div>
  );
}

export default CareerCoachEnrollment;
